class Help {
  constructor() {
    this.scriptChunks = [
      '!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});',
      'window.Beacon("init", "f48d2025-7e23-4511-857d-9ff6624aa4d1")',
    ];
    this.button = document.getElementById('js_help-button');
    this.load = false;
    this.countOfLoading = 0;
    this.maxCountOfLoading = 20;
    this.timerId = "";
  }

  init() {
    if (this.button) {
      this.handleClick();
    }
  }

  handleInProgress(status) {
    if (status) {
      this.button.classList.add('disabled');
    } else {
      this.button.classList.remove('disabled');
    }
  }

  handleClick() {
    this.button.addEventListener('click', () => {
      this.handleInProgress(true);
      if (!this.load) {
        this.handleInjection()
      }
      this.handleLoad();
    });
  }

  handleInjection() {
    this.scriptChunks.forEach((chunk) => {
      const script = document.createElement('script');
      script.innerHTML = chunk;
      document.body.appendChild(script);
      this.load = true;
    });
  }

  handleLoad() {
    if (this.countOfLoading >= this.maxCountOfLoading) {
      this.handleInProgress(false);
      clearTimeout(this.timerId);
    } else if (window.Beacon === undefined) {
      this.timerId && clearTimeout(this.timerId);
      this.timerId = setTimeout(() => { this.handleLoad() }, 1000);
    } else {
      this.button.style.display = "none";
      window.Beacon("open");
    }
    this.countOfLoading++;
  }

}

module.exports = Help;
